import React from "react";
import { AboutData } from "../../assets/data/aboutData";
import Button from "../shared/Button";
import "./About.css";

function About() {
  return (
    <div className="about-section" id="about">
      <div className="about-img">
        <img src="/img/hire.jpg" alt="doctor-2" />
      </div>
      <div className="about-description">
        <h3>About Us</h3>
        <h1>Welcome to Our Clinic</h1>
        <p>
          We provide the most full medical services, so every person could have
          the opportunity to receive qualitative medical help. One of the most
          important factors about people’s lives is the information of, the use
          of, and the growing knowledge of medicine. Medicine is a form of art.
          It depends on how skillfully doctors apply their knowledge when
          dealing with patients.
        </p>
        <ul>
          {AboutData.map((data, index) => {
            return (
              <li key={index}>
                <i>{data.icon}</i>
                {data.info}
              </li>
            );
          })}
        </ul>
        <Button>
          <span>+</span>
          Book Now!
        </Button>
      </div>
    </div>
  );
}

export default About;
